import React from "react";
import Typography, { TypographyProps } from "@material-ui/core/Typography";

type Props = TypographyProps & {
  [other: string]: any;
  newlineToBr?: boolean;
  nobr?: boolean;
  block?: boolean;
};

export function Body(props: Props) {
  const {
    block,
    children,
    color = "inherit",
    newlineToBr,
    nobr,
    style: stypeProp = {},
    ...rest
  } = props;

  const style: React.CSSProperties = {
    whiteSpace: nobr ? "nowrap" : "initial",
    ...stypeProp
  };

  return (
    <Typography
      component={"span" as any}
      color={color}
      style={style}
      display={block ? "block" : undefined}
      {...rest}
    >
      {newlineToBr ? nl2br(children) : children}
    </Typography>
  );
}

function nl2br(input) {
  return input
    .toString()
    .split("\n")
    .map((item, key) => (
      <React.Fragment key={key}>
        {item}
        <br />
      </React.Fragment>
    ));
}

export default Body;
